module.exports = __webpack_public_path__ + "static/media/BFCM_ebook.aa5af050.png";